import React from "react";
import PinterestIcon from "mdi-material-ui/Pinterest";

export default function Pinterest(props) {
  return <PinterestIcon htmlColor="#BD081C" {...props} />;
}
